<script setup lang="ts">
import AppButton2 from '~/components/AppButton2.vue'
import CmsCustomComponent from '~/layers/cms/app/components/cms/CmsCustomComponent.vue'
import CmsLink from '~/layers/cms/app/components/cms/CmsLink.vue'
import type { CmsCustomComponentType } from '~/layers/cms/app/types/cmsTypes'

const props = defineProps<{
  cmsDataPath: (string | number)[]
}>()

const nazwa_komponentu = 'Modules with padding/Button2'

const component_default_values: CmsCustomComponentType = {
  padding: { value: undefined, selectValues: ['px-xl', 'px-2xl', 'px-4xl', 'px-0'], default_value: 'Lorem Ipsum', settingType: 'select', setting_label: 'zmien padding' },
  id: { value: undefined, default_value: 'Lorem Ipsum', settingType: 'text', setting_label: 'zmien id' }
}
</script>

<template>
  <CmsCustomComponent
    v-slot="{ component_values }"
    :cms-data-path="[...props.cmsDataPath]"
    :defaults="component_default_values"
    :component-name="nazwa_komponentu"
    :open-options="true"
  >
    <div
      :class="component_values?.padding?.value"
    >
      <CmsLink
        v-slot="{ link }"
        :cms-data-path="[...props.cmsDataPath, 'component_data', 'link']"
        class="w-fit"
      >
        <AppButton2
          :href="link?.href"
          :target="link?.target"
        >
          <span class="link-text">{{ link?.link_text ?? 'Lorem ipsum' }}</span>
        </AppButton2>
      </CmsLink>
    </div>
  </CmsCustomComponent>
</template>
